var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.8335 4.83342H3.00016C2.55814 4.83342 2.13421 5.00902 1.82165 5.32158C1.50909 5.63414 1.3335 6.05806 1.3335 6.50009V14.0001C1.3335 14.4421 1.50909 14.866 1.82165 15.1786C2.13421 15.4912 2.55814 15.6668 3.00016 15.6668H10.5002C10.9422 15.6668 11.3661 15.4912 11.6787 15.1786C11.9912 14.866 12.1668 14.4421 12.1668 14.0001V13.1668M11.3335 3.16676L13.8335 5.66676M14.9877 4.48759C15.3159 4.15938 15.5003 3.71424 15.5003 3.25009C15.5003 2.78594 15.3159 2.34079 14.9877 2.01259C14.6595 1.68438 14.2143 1.5 13.7502 1.5C13.286 1.5 12.8409 1.68438 12.5127 2.01259L5.50016 9.00009V11.5001H8.00016L14.9877 4.48759Z",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.48fb3e09576a12a19a117955f336d11f.svg";
export { ForwardRef as ReactComponent };